<template>
    <div>
        <span>
            {{ generateName() }}
        </span>
    <!--    <hts-modal -->
    <!--      :show="openPopupEditStatus" -->
    <!--      :title="$t('labels.editStatusQuote')" -->
    <!--      type="confirm" -->
    <!--      :content="$t('labels.confirmEditStatusQuote')" -->

    <!--      @hide="openPopupEditStatus = false" -->
    <!--      @confirm="handelEditStatus" -->
    <!--    /> -->
    </div>
</template>

<script lang="ts" setup>
import { addQuote } from './ignore/imports/form'
const { $formatters } = useNuxtApp()

const props = defineProps({
  dataCreateQuote: {
    type: Object as PropType<addQuote>,
    required: true
  }
})
const { dataCreateQuote } = toRefs(props)

const generateName = () => {
  const typeCommodity = []
  if (dataCreateQuote.value) {
    if (
      dataCreateQuote.value.typeCommodity === 'NORMAL' &&
      dataCreateQuote.value.goodType === 'SOLID' &&
      dataCreateQuote.value.typeDangerous === 'NOTDANGEROUS' &&
      dataCreateQuote.value.typeFragileGoods === 'NOTFRAGILE' &&
      dataCreateQuote.value.typeReefer === 'NOTREEFER'
    ) {
      typeCommodity.push($t('labels.ordinaryGoods'))
    } else {
      if (dataCreateQuote.value.goodType === 'LIQUID') {
        typeCommodity.push($t('labels.liquidGoods'))
      }
      if (dataCreateQuote.value.goodType === 'GAS') {
        typeCommodity.push($t('labels.gasGoods'))
      }
      if (dataCreateQuote.value.typeReefer === 'REEFER') {
        typeCommodity.push($t('labels.coolGoods'))
      }
      if (dataCreateQuote.value.typeDangerous === 'DANGEROUS') {
        typeCommodity.push($t('labels.hazardousGoods'))
      }
      if (dataCreateQuote.value.typeFragileGoods === 'FRAGILE') {
        typeCommodity.push($t('labels.fragileGoods'))
      }
      if (dataCreateQuote.value.typeCommodity === 'OVERWEIGHT') {
        typeCommodity.push($t('labels.superHeavyGoods'))
      }
    }
  }

  return typeCommodity.join(', ')
}

</script>
